import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { IconButtonProps } from 'components/Icons/constants';
import CalendarSvg from './calendar.svg';

export const CalendarIcon = (props: any) => <Icon component={CalendarSvg} {...props} />;

export const CalendarIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  ({ size = 'medium', iconSize = 24, ...props }, ref) => (
    <Button
      ref={ref}
      type={ButtonType.OutlineIcon}
      icon={<CalendarSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
CalendarIconButton.displayName = 'CalendarIconButton';
